export default __webpack_public_path__ + "static/media/about_rectangle_4.c3e3d7b2.svg";